import { useEffect, useMemo } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { CognitoUser } from '@/types'
import { useLocalStorage } from './useLocalStorage'
import { HOME_PATH } from '@/utils/constants'
import useAppStore, { clearAllStores } from '@/store/useAppStore'

export const useAuth = () => {
  const resetAllSlices = useAppStore((state) => state.resetAll)

  const [user, setUser] = useLocalStorage('ewUser', null)
  const [basicInfo, setUserBasicInfo] = useLocalStorage('ewBasicInfo', null)
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()

  // call this function when you want to authenticate the user
  const login = (data: CognitoUser) => {
    setUser(data)

    // Check for redirect parameter
    const redirectPath = searchParams.get('redirect')
    if (redirectPath) {
      navigate(redirectPath)
    } else {
      navigate(HOME_PATH)
    }
  }

  // call this function to sign out logged in user
  const logout = () => {
    setUser(null)
    clearAllStores()

    navigate('/login', { replace: true })
  }

  const reset = async () => {}

  const value = useMemo(
    () => ({
      basicInfo,
      setUserBasicInfo,
      user,
      login,
      logout,
    }),
    [user],
  )
  return value
}
